import BluebirdPromise from 'bluebird';

BluebirdPromise.config({
  cancellation: true,
});
